import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  back: () => void
  currentStep: number
  disableBack: boolean
  stepLength: number
  disableNext: boolean | undefined
}

function StepperFormFooter({ back, currentStep, disableBack, stepLength, disableNext }: Props) {
  const { t } = useTranslation()

  const noCosign = currentStep === 1 && !disableBack

  return (
    <footer className="form-footer">
      <button disabled={disableBack} type="button" onClick={back} className="btn btn-grey">
        <i className={`fa-light ${noCosign ? 'fa-user-minus' : 'fa-arrow-left'}`} />
        <span>{noCosign ? t<string>('coapplicant.noCosign') : t<string>('common.back')}</span>
      </button>
      <div className="step-count">
        <span>
          {currentStep} / {stepLength}
        </span>
      </div>

      <button type="submit" className="btn btn-blue" disabled={disableNext}>
        <span>{t('common.next')}</span>
        <i className="fa-regular fa-arrow-right" />
      </button>
    </footer>
  )
}

export default StepperFormFooter
